import { apiClient } from '../../../services/apiClient';
import type { ComponentData, DateRange, ReportingComponentProps } from './BaseReportingComponent.types';

export async function tryCustomReportingFetcher(
  customDataFetcher: NonNullable<ReportingComponentProps['customDataFetcher']>,
  artifactId: string
): Promise<ComponentData | null> {
  try {
    return await customDataFetcher(artifactId);
  } catch (customErr) {
    console.info('[BaseReportingComponent] customDataFetcher failed, falling through to API:', customErr);
    return null;
  }
}

export function parseReportingFetchError(error: unknown): string {
  if (error && typeof error === 'object' && 'response' in error) {
    const axiosError = error as { response?: { data?: { detail?: string } } };
    return axiosError.response?.data?.detail || 'Failed to fetch component data';
  }
  if (error instanceof Error) {
    return error.message;
  }
  return 'Unknown error occurred';
}

export async function fetchStandardReportingComponent(
  artifactId: string,
  componentType: string,
  effectiveDateRange: DateRange,
  effectiveShowProjections: boolean,
  includeHistorical: boolean
): Promise<ComponentData> {
  const params = new URLSearchParams();
  params.append('artifact_id', artifactId);

  if (effectiveDateRange.startDate) {
    params.append('start_date', effectiveDateRange.startDate.toISOString().split('T')[0]);
  }
  if (effectiveDateRange.endDate) {
    params.append('end_date', effectiveDateRange.endDate.toISOString().split('T')[0]);
  }
  params.append('include_projections', effectiveShowProjections.toString());
  params.append('include_historical', includeHistorical.toString());

  const response = await apiClient.get<ComponentData>(
    `/dashboard-components/${componentType}?${params.toString()}`
  );
  return response.data;
}
